import { theme_default } from './chunk-P4IX5WV7.mjs';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material';
import { jsxs, jsx } from 'react/jsx-runtime';

var MinimalismThemeProvider = (props) => {
  return /* @__PURE__ */ jsxs(ThemeProvider, { theme: theme_default, children: [
    /* @__PURE__ */ jsx(CssBaseline, {}),
    props.children
  ] });
};
var ThemeProvider_default = MinimalismThemeProvider;

export { ThemeProvider_default };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-IAPGZBP4.mjs.map